import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles(() => ({
  root: {
    overflowY: "scroll",
    overflowX: "hidden",
    scrollSnapType: "y mandatory",
    // TODO: add constant
    paddingTop: 120,
    paddingBottom: 72,
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  container: {},
  content: {
    padding: "8px 16px 8px",
    gap: 16,
    display: "grid",
  },
  title: {
    paddingTop: 14,
    paddingBottom: 10,
  },
  section: {
    scrollSnapAlign: "start",
  },
  noLoadMore: {
    height: "unset",
  },
}));
